<template>
    <el-dialog :visible.sync="visible" width="300px" title="提示" :close-on-click-modal="false" :show-close="false" destroy-on-close>
        <div style="text-align: center;">{{ isRight ? '恭喜你，答对了！' : '很遗憾，答错了！请重新学习。' }}</div>
        <el-button type="primary" class="submit-btn" @click="submit">{{ isRight ? '继续学习' : '重新学习' }}</el-button>
    </el-dialog>
</template>
<script>
export default {
    name: 'answerResultDialog',
    props: ['show', 'isRight'],
    watch: {
        show(val) {
            if (val) {
                this.visible = true
            } else {
                this.visible = false
            }
        }
    },

    data() {
        return {
            visible: false,
        }
    },
    methods: {
        submit() {
            this.$emit('goonOrNot',this.isRight)
            this.visible = false
        }
    },
}
</script>

<style lang="less" scoped>

/deep/.el-dialog__header{text-align: center;}

.submit-btn {
    width: 140px;
    height: 40px;
    margin-left: 55px;
    margin-top: 30px;
    border-radius: 20px;
}
</style>


// WEBPACK FOOTER //
// ./src/page/train/videoDetail/answerResultDialog.vue